<!-- 盘点明细 -->
<template>
    <div class="page-content">
        <c-header pageName="盘点明细"></c-header>
        <div class="header flex-wrap">
            <section>盘点单号 : {{checkDetailInfo.checkSn}}</section>
            <section>仓库 : {{checkDetailInfo.warehouseName}}</section>
            <section>
                库区 :
                <span
                    @click="showAreaPicker=true"
                >{{selectArea.locationAreaName?selectArea.locationAreaName:" 请选择库区"}}</span>
            </section>
            <section class="search-tool" v-if="!isSearchBan">
                <van-field v-model="searchStorageLocation" autofocus/>
                <span @click="onSearchStorageLocation">请扫描库位</span>
            </section>
            <section class="search-tool" v-else>
                <van-field v-model="searchBan" autofocus/>
                <span @click="onSearchBan">请扫描板号</span>
            </section>
            <section v-show="storageLocation">库位 : {{searchStorageLocation}}</section>
            <section v-show="checkDetailInfo">板号 : {{searchBan}}</section>
        </div>
        <!-- 盘点情况 -->
        <div class="check-main flex-wrap" v-show="checkDetailInfoMain.total">
            <div class="check-main-title flex-wrap">
                <section>盘点量 : {{checkDetailInfoMain.total}}</section>
                <section>已盘点 : {{checkDetailInfoMain.chekedQty}}</section>
                <section>未盘点 : {{checkDetailInfoMain.unCheckQty}}</section>
            </div>
            <div class="check-main-order flex-wrap">
                <section
                    v-for="(item,index) in checkDetailInfoMain.unCheckStockDetailResponseVOS"
                    :key="index"
                >
                    <span>库位 : {{item.checkStockDetailExtendResponseVO.storageLocationName}}</span>
                    <span>板号 : {{item.bandSn}}</span>
                </section>
            </div>
        </div>
        <div class="check-sub flex" v-show="selectArea.locationAreaName">
          <section @click="onCheckSub">盘点确认</section>
        </div>
        <van-picker
            v-show="showAreaPicker"
            :columns="areaTextList"
            @confirm="onAreaConfirm"
            show-toolbar
            @cancel="showAreaPicker = false"
        />
        <c-controller
            v-show="showCheckController"
            @closeDialog="onColseCheckController"
            :info="bandInfo"
            @checkDetailResultSaveSuccess="onCheckDetailResultSaveSuccess"
        ></c-controller>
    </div>
</template>

<script>
import Header from "../components/headerNav.vue";
import CheckController from "../components/checkControllerDialog.vue";
export default {
    data() {
        return {
            searchStorageLocation: "", // 搜索库位
            searchBan: "", // 搜素板号
            isSearchBan: false, // 是否为扫描版号
            checkDetailId: "",
            storageLocation: {}, // 库位信息
            bandInfo: {}, // 板号信息
            checkDetailInfo: {},
            showAreaPicker: false, // 库区选择器
            areaList: [], // 库区列表
            areaTextList: [], //
            selectArea: {}, // 选择的库区
            checkDetailInfoMain: {}, // 盘点明细的已盘点和未盘点状态情况
            showCheckController: false // 显示盘点操作弹框
        };
    },
    components: {
        "c-header": Header,
        "c-controller": CheckController
    },
    mounted() {
        this.checkDetailId = this.$route.query.checkDetailId;
        this.getCheckStockDetail();
    },
    methods: {
        // 获取盘点单详情 getCheckStockDetail
        getCheckStockDetail() {
            let param = {
                id: this.checkDetailId
            };
            this.$post(this.URL.getCheckStockDetail, param).then(res => {
                if (res.success) {
                    this.checkDetailInfo = res.data;
                    this.areaList = res.data.checkStockDetailAreaResponseVOS;
                    this.areaTextList = this.areaList.map(item => {
                        return item.locationAreaName;
                    });
                } else {
                    this.$toast.fail(res.message);
                }
            });
        },
        // 扫描库位
        onSearchStorageLocation() {
            if (!this.selectArea.locationAreaName) {
                this.$toast.fail("请选择库区");
                return;
            }
            this.isSearchBan = true;
        },
        // 扫描板号
        onSearchBan() {
            if (!this.selectArea.locationAreaName) {
                this.$toast.fail("请选择库区");
                return;
            }
            let param = {
                bandSn: this.searchBan,
                checkId: this.checkDetailInfo.id,
                storageLocationName: this.searchStorageLocation
            };
            this.$post(this.URL.getCheckBanInfo, param).then(res => {
                if (res.success) {
                    this.bandInfo = res.data;
                    this.showCheckController = true;
                } else {
                    this.$toast.fail(res.message);
                }
            });
        },
        // 库区选择确认
        onAreaConfirm(value, index) {
            this.selectArea = this.areaList[index];
            this.showAreaPicker = false;
            this.getCheckStockDetailInfo();
        },
        // 获取盘点单的 盘点情况
        getCheckStockDetailInfo() {
            let param = {
                locationAreaName: this.selectArea.locationAreaName,
                checkId: this.checkDetailInfo.id
            };
            this.$post(this.URL.getCheckStockDetailInfo, param).then(res => {
                if (res.success) {
                    this.checkDetailInfoMain = res.data;
                } else {
                    this.$toast.fail(res.message);
                }
            });
        },
        // 关闭盘点操作弹框
        onColseCheckController() {
            this.showCheckController = false;
        },
        // 盘点操作保存成功事件（1）刷新
        onCheckDetailResultSaveSuccess() {
            this.showCheckController = false;
            if (this.selectArea.locationAreaName) {
                this.getCheckStockDetailInfo();
            }
        },
        // 盘点确认
        onCheckSub(){
          this.$post(this.URL.checkConfirm, {id:this.checkDetailId}).then(res => {
                if (res.success) {
                    this.$toast.success("盘点确认成功");
                    this.$router.push("/checkStock");
                } else {
                    this.$toast.fail(res.message);
                }
            });
        }
    }
};
</script>
<style lang='scss' scoped>
.header {
    padding: 1rem;
    font-size: 0.9rem;
    color: #444;
    section {
        display: flex;
        width: 100%;
        height: 1.8rem;
        align-items: center;
        span {
            margin-left: 0.2rem;
        }
    }
    .search-tool {
        width: 100%;
        height: 2.5rem;
        align-items: center;
        border: 1px solid #f0f0f0;
        border-radius: 0.5rem;
        padding-left: 1rem;
        font-size: 0.9rem;
        margin: 0.3rem 0;
        .van-cell {
            display: inline-flex;
            align-items: center;
            height: 2.2rem;
            padding: 0;
        }
        .van-cell:not(:last-child)::after {
            border-bottom: none;
        }
        span {
            display: inline-flex;
            height: 2.5rem;
            align-items: center;
            justify-content: center;
            width: 8rem;
            border-left: 1px solid #f0f0f0;
        }
    }
}
.check-main {
    color: #444;
    font-size: 0.85rem;
    padding: 0 1rem 1rem 1rem;
    .check-main-title {
        background-color: #f0f0f0;
        border-top-right-radius: 0.2rem;
        border-top-left-radius: 0.2rem;
        section {
            display: inline-flex;
            height: 2rem;
            width: 33.33%;
            justify-content: center;
            align-items: center;
            color: #dc6350;
        }
    }
    .check-main-order {
        height: 18rem;
        overflow-y: auto;
        border: 1px solid #f0f0f0;
        section {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            font-size: 0.8rem;
            height: 3rem;
            padding-left: 1rem;
            align-content: center;
            border-bottom: 1px dashed #f0f0f0;
            span {
                display: flex;
                width: 100%;
            }
        }
    }
}
.check-sub{
  font-size: 0.85rem;
  color: #fff;
  height: 2rem;
  justify-content: center;
  section{
    display: inline-flex;
    width: 18rem;
    background-color: #dc6350;
    height: 2rem;
    align-items: center;
    justify-content: center;
    border-radius: 0.3rem;
  }
}
.van-picker {
    display: flex;
    width: 100%;
    justify-content: center;
    position: fixed;
    bottom: 0;
    flex-wrap: wrap;
    >>> .van-picker__toolbar {
        display: flex;
        width: 100%;
        .van-picker__cancel,
        .van-picker__confirm {
            color: #dc6350;
        }
    }
    >>> .van-picker__columns {
        display: flex;
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/CheckStockDetail.vue